import React, { FC } from "react";
import { useTranslation } from "next-i18next";
import { BiDownload } from "react-icons/bi";
import styles from "./MediaAssets.module.scss";


const Assets = [
  {
    link: 'https://drive.google.com/drive/folders/1JLk8ehBuUlCxtK49PysN00F8y1HdqCZt?usp=sharing',
    key: 'fact-sheet'
  },
  {
    link: 'https://drive.google.com/drive/folders/18J2p6lUQdAXb8Trvz9-tNO0rrE8fixp3?usp=sharing',
    key: 'pitch-deck'
  },
  {
    link: 'https://drive.google.com/drive/folders/1w6pHFRP2hT4-Izz8d8b1t3zQucX2r5En?usp=sharing',
    key: 'press-images'
  },
  {
    link: 'https://drive.google.com/drive/folders/149lDv-4soReCnqN8Ld87ivhpl2ye1EoH?usp=sharing',
    key: 'logos'
  },
]

const MediaAssets: FC = () => {
  const {t} = useTranslation('media-kit')

  return (
    <section className={styles.mediaAssets}>
      <h2 className={styles.title}>{t('media-assets')}</h2>
      <ul className={styles.assetList}>
        {Assets.map((asset, i) => (
          <li key={i}>
            <a href={asset.link} target="_blank" rel="noopener noreferrer">
              {t(asset.key)}
              <BiDownload />
            </a>
          </li>
        ))}
        
      </ul>
    </section>
  )
}

export default MediaAssets